import { render, staticRenderFns } from "./swapResultView.vue?vue&type=template&id=448aa447&scoped=true&"
import script from "./swapResultView.vue?vue&type=script&lang=js&"
export * from "./swapResultView.vue?vue&type=script&lang=js&"
import style0 from "./swapResultView.vue?vue&type=style&index=0&id=448aa447&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448aa447",
  null
  
)

export default component.exports